
import { useAdminSettings } from '~/composables/api/useAdminSettings'
import { useAuth } from '~/composables/auth/useAuth'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(async (to) => {
  // Skip the middleware on server-side during initial page load
  if (process.server) return

  try {
    const config = useRuntimeConfig()
    const authStore = useAuthStore()
    const { logout } = useAuth()
    const { getMaintenanceMode } = useAdminSettings()
    
    const maintenanceMode = await getMaintenanceMode()
    
    if (import.meta.client) {
      window.dispatchEvent(new CustomEvent('maintenanceModeStatus', { 
        detail: { status: maintenanceMode.status } 
      }))
    }
    
    if (!maintenanceMode.status) {
      return
    }

    if (authStore.isAdmin) {
      return
    } else if (authStore.user) {
      console.log('Maintenance mode activated: logging out user and clearing cookies')
      
      try {
        await $fetch(`${config.public.apiBase}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
        })
      } catch (error) {
        console.warn('Failed to call logout endpoint during maintenance:', error)
      }
      
      logout("/under-maintenance")
    }

    const allowedRoutes = [
      '/',
      '/under-maintenance',
      '/admin-login',
      '/about',
      '/rules',
      '/sponsors',
      '/wheel',
      '/team-picker-preview',
      '/terms',
      '/privacy',
      '/welcome/vendor-inquiry',
    ]

    const isAllowedRoute = allowedRoutes.some(route => 
      to.path === route || to.path.startsWith(route + '/')
    )

    if (isAllowedRoute) {
      return
    }

    return navigateTo('/under-maintenance')

  } catch (error) {
    console.warn('Error checking maintenance mode:', error)
    
    return
  }
})
